import { runtime } from '../../runtime/Runtime';
export class ActorInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get isAttachedActor() {
        return this instanceof runtime.class.AttachedTrait;
    }
    get isRenderable() {
        if (this.isAttachedActor && this.actor.attachedInfo.isAttachedContent)
            return true;
        if (this.actor instanceof runtime.class.TraitConditionEvaluator)
            return false;
        return !this.isAttachedActor;
    }
    get hasMultipleAspects() {
        return this.actor.actorStore.aspects.size > 1;
    }
}
